import { AlertService } from '../alert/alert.service';
import { AuthenticationService } from './authentication.service';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';


/**
*  This class represents the lazy loaded LoginComponent.
*/

@Component({
  selector: 'app-login-cmp',
  templateUrl: 'login.component.html'
})

export class LoginComponent implements OnInit {

  model: any = {};
  loading = false;
  returnUrl: string;
  wrongCredentials: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private alertService: AlertService) { }

  ngOnInit() {

    this.wrongCredentials = false;
    // reset login status
    this.authenticationService.logout();

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    if (this.returnUrl == null || this.returnUrl.length === 0 || this.returnUrl.length === 1) {
      this.returnUrl = '/sec';
      this.router.navigate([this.returnUrl]);
    }
  }

  login() {
    this.loading = true;
    this.authenticationService.login(this.model.username, this.model.password)
      .subscribe(
      data => {

        this.updateErrorMessage();
        this.router.navigate([this.returnUrl]);
      },
      error => {
        this.alertService.error(error);
        this.loading = false;
        this.updateErrorMessage();
      });
  }
  updateErrorMessage() {
    let cu = localStorage.getItem('currentUser');
    this.wrongCredentials = (cu == null);

  }
}




// WEBPACK FOOTER //
// ./src/app/login/login.component.ts